import React from 'react';
import PropTypes from 'prop-types';
import { Quote } from '../../quotes/quote';
import { Modal } from '@ami/react/core';

export default class QuoteExpireModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
    };
  }

  static propTypes = {
    entityId: PropTypes.string.isRequired,
    onChanged: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
  };

  hide = () => this.props.onHide();

  save = async () => {
    this.setState({ saving: true });
    await Quote.expire(this.props.entityId)
      .then(() => {
        this.props.onChanged();
        this.hide();
      })
      .finally(() => this.setState({ saving: false }));
  };

  render() {
    const { show } = this.props;
    const { saving } = this.state;

    if (!show) return null;

    return (
      <Modal
        title="Expire Quote"
        show={show}
        onShowUpdated={() => {}}
        okTitle="Yes"
        cancelTitle="No"
        onOk={this.save}
        showCancel={true}
        onCancel={this.hide}
        submitting={saving}
      >
        <p>Are you sure you want to expire this quote?</p>
      </Modal>
    );
  }
}
